import { Provider } from '@angular/core';
import {
  Configuration,
  ConfigurationId as Provide,
  ConfigurationImpl,
} from '@daas-consulting/production/shared/cross/configuration';
import { environment } from '../../environments/environment';

export const ConfigurationProvider: Provider = {
  provide: Provide,
  useFactory(): Configuration {
    const rv = new ConfigurationImpl({
      ...environment,
      environment: environment.name,
    });
    const map = new Map();

    // Agrega solo las propiedades que no existen en `rv`
    Object.entries(environment).forEach(([key, value]) => {
      if (!(key in rv)) {
        map.set(key, value);
      }
    });
    Object.assign(rv, Object.fromEntries(map));
    return rv;
  },
};
